module.exports = __webpack_public_path__ + "static/media/tim-1440.a1cbd98c.jpeg";